<ca-conversation-base-list
  [gridId]="gridId"
  [dataSource]="dataSource"
  [gridColumns]="gridColumns"
  (conversationIdChange)="onConversationIdChanged($event)">
</ca-conversation-base-list>
